export type AppLocale = 'en' | 'id'

export function resolveAppLocale(params: {
  language?: string | null
  country?: string | null
  timezone?: string | null
}): AppLocale {
  const normalizedLanguage = String(params.language ?? '').trim().toLowerCase()
  if (normalizedLanguage === 'id' || normalizedLanguage.startsWith('id-') || normalizedLanguage === 'indonesian') {
    return 'id'
  }
  if (normalizedLanguage === 'en' || normalizedLanguage.startsWith('en-') || normalizedLanguage === 'english') {
    return 'en'
  }

  const normalizedCountry = String(params.country ?? '').trim().toLowerCase()
  if (normalizedCountry === 'indonesia' || normalizedCountry === 'id') {
    return 'id'
  }
  if (
    normalizedCountry === 'united states'
    || normalizedCountry === 'united states of america'
    || normalizedCountry === 'us'
    || normalizedCountry === 'usa'
  ) {
    return 'en'
  }

  const normalizedTimezone = String(params.timezone ?? '').trim()
  if (/^Asia\/(Jakarta|Makassar|Jayapura)$/i.test(normalizedTimezone)) {
    return 'id'
  }

  return 'en'
}
